import * as Common from "../../commons/common"

export class EntranceCompareSheetListCondition{
  month: string = ""
  sheet_group_key: string = ""
  curriculum_id: string = ""
  saiten_flg: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export class RowSpanInfo{
  sheet_id: number
  sheet_group_key: number
  count: number

  constructor(sheet_id: number, sheet_group_key: number, count: number){
    this.sheet_id = sheet_id;
    this.sheet_group_key = sheet_group_key;
    this.count = count;
  }
}